import React from 'react';
import RatingForm from './components/RatingForm';
import './App.css';

function App() {
  return (
    <div className="App">
      <RatingForm />
    </div>
  );
}

export default App;

